import { Component, OnDestroy, OnInit } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { SzamlazoService } from '../szamlazo.service';
import { SzerkZar, SzerkZarService } from '../../components/szerk-zar/szerk-zar.service';

/*  VEVŐK – a cég vevőtörzse. Belföldi cégnél az adószám kötelező (a NAV-nak is megy), és a NAV-nál
 *  ellenőrizhető: a cég saját technikai felhasználójával lekérdezzük, a név és a cím ki is töltődik. */
@Component({
  selector: 'app-szamlazo-vevok',
  templateUrl: './vevok.component.html',
  styleUrls: ['../../naplo/naplo-shared.scss', '../szamlazo-shared.scss'],
})
export class VevokComponent implements OnInit, OnDestroy {
  lista: any[] = [];
  kereso = '';
  szerk: any = null;
  navFut = false;
  zar: SzerkZar | null = null;    // a nyitott vevő szerkesztési zárja
  private zarKor = 0;
  private sub?: Subscription;
  constructor(public sz: SzamlazoService, private toast: ToastController, private szerkZar: SzerkZarService) {}
  get u() { return this.sz.aktiv.ugyfelId; }
  get ir() { return this.sz.ir; }

  async ngOnInit() { await this.sz.init(); this.sub = this.sz.aktiv$.subscribe(() => this.frissit()); }
  ngOnDestroy() { this.sub?.unsubscribe(); this.zarElenged(); }
  async frissit() {
    if (!this.u) { this.lista = []; return; }
    try { this.lista = await this.sz.get(`/partnerek/${this.u}`); } catch (e: any) { this.lista = []; this.hiba(e?.error?.error || 'Nem sikerült betölteni.'); }
  }
  get lathato() {
    const k = this.kereso.trim().toLowerCase();
    return k ? this.lista.filter((p) => String(p.nev).toLowerCase().includes(k) || String(p.adoszam || '').includes(k)) : this.lista;
  }
  tipusNev(t: string) { return ({ belfoldi: 'belföldi cég', maganszemely: 'magánszemély', eu: 'EU-s cég', harmadik: 'harmadik ország' } as any)[t] || t; }
  uj() { this.zarElenged(); this.szerk = { id: null, nev: '', tipus: 'belfoldi', adoszam: '', kozossegi_adoszam: '', orszag: 'HU', irsz: '', telepules: '', cim: '', email: '', megjegyzes: '', aktiv: true }; }
  nyit(p: any) { this.szerk = { ...p, aktiv: !!Number(p.aktiv) }; this.zarFoglal(String(p.id)); }
  /*  SZERKESZTÉSI ZÁR (components/szerk-zar): a megnyitott vevőt közben más nem írhatja felül. A késve
   *  megjött zárat (közben bezárták, másikat nyitottak) rögtön elengedjük. */
  private async zarFoglal(id: string) {
    this.zarElenged();
    if (!this.ir) return;
    const kor = this.zarKor;
    const z = await this.szerkZar.foglal('szamlazo', 'szamlazo_partner', id, { ujratolt: () => this.ujratolt(id) });
    if (kor !== this.zarKor || String(this.szerk?.id) !== id) { z?.felenged(); return; }
    this.zar = z;
  }
  private zarElenged() { this.zarKor++; this.zar?.felenged(); this.zar = null; }
  bezar() { this.szerk = null; this.zarElenged(); }
  private async ujratolt(id: string) {
    this.lista = await this.sz.get(`/partnerek/${this.u}`);
    const p = this.lista.find((x) => String(x.id) === id);
    if (p && String(this.szerk?.id) === id) this.szerk = { ...p, aktiv: !!Number(p.aktiv) };
  }
  async navLekeres() {
    this.navFut = true;
    try {
      const r: any = await this.sz.post(`/partner/${this.u}/nav`, { adoszam: this.szerk.adoszam });
      if (!r.ervenyes) { this.hiba('A NAV szerint ez az adószám nem érvényes.'); return; }
      Object.assign(this.szerk, { nev: r.nev || this.szerk.nev, adoszam: r.adoszam || this.szerk.adoszam, irsz: r.irsz || this.szerk.irsz,
        telepules: r.telepules || this.szerk.telepules, cim: r.cim || this.szerk.cim });
      this.ok('Érvényes adószám – a NAV adataival kitöltve.');
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült a NAV-lekérdezés.'); }
    finally { this.navFut = false; }
  }
  async ment() {
    if (this.zar && !this.zar.irhato) return;
    try { await this.sz.post(`/partner/${this.u}`, this.szerk); this.bezar(); await this.frissit(); this.ok('Vevő mentve.'); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
  }
  private async ok(m: string) { (await this.toast.create({ message: m, duration: 2600, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 4000, color: 'danger' })).present(); }
}
